import React from 'react';
import { Link } from 'react-router-dom';
import HomeSectionLink from '../common/HomeSectionLink';
import { buildContactMailto } from '../../constants/contact';
import { GITHUB_URL } from '../../constants/site';
import { useGoToHome } from '../../hooks/useGoToHome';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  const goToHome = useGoToHome();

  const handleContactClick = () => {
    window.location.href = buildContactMailto('Вопрос — marketDir');
  };

  return (
    <footer className="odd-footer">
      <div className="footer-shell">
        <div className="footer-top">
          <div className="footer-brand-col">
            <Link className="footer-brand" to="/" aria-label="marketDir" onClick={goToHome}>
              <span className="footer-logo-mark">
                market<em>Dir</em>
              </span>
            </Link>
            <p className="footer-tagline">Знает, что делать</p>
          </div>

          <nav className="footer-links" aria-label="Footer">
            {GITHUB_URL ? (
              <a className="footer-link" href={GITHUB_URL} target="_blank" rel="noopener noreferrer">
                GitHub
              </a>
            ) : null}
            <HomeSectionLink className="footer-link" sectionId="privacy-policy">
              Конфиденциальность
            </HomeSectionLink>
            <button type="button" className="footer-link" onClick={handleContactClick}>
              Контакты
            </button>
          </nav>
        </div>

        <div className="footer-bottom" id="privacy-policy">
          <p className="footer-copyright">{`© ${year} marketDir. Все права защищены.`}</p>
          <p className="footer-legal">
            Пользуясь сайтом, вы соглашаетесь на обработку персональных данных, включая использование
            сервисов веб-аналитики.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
